import { Box, Paper } from "@mui/material";
import React from "react";
import { PUZZLE_GRID_COLORS } from "../../../services/ColorService";

const WordGrid = ({ gridSize = 6, currentWord = null, characterIndex = -1, cellSize = 40 }) => {
    // Initialize empty grid
    const grid = Array(gridSize).fill(null).map(() => Array(gridSize).fill(""));

    // Fill grid with word positions if currentWord exists
    // Only show characters up to characterIndex
    if (currentWord && currentWord.positions) {
        currentWord.positions.forEach((pos, index) => {
            if (pos.row >= 0 && pos.row < gridSize && pos.col >= 0 && pos.col < gridSize) {
                // Only show characters up to the current characterIndex
                if (characterIndex >= 0 && index <= characterIndex) {
                    grid[pos.row][pos.col] = pos.value;
                }
            }
        });
    }

    const gap = 0;
    const padding = 8;
    const containerSize = (cellSize * gridSize) + (gap * (gridSize - 1)) + (padding * 2);

    const fontNorm = Math.max(0.65, Math.min(0.9, cellSize * 0.028));
    const fontHi = Math.max(0.75, Math.min(1.05, cellSize * 0.032));

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 0, lineHeight: 0 }}>
            <Paper
                elevation={3}
                sx={{
                    p: 1,
                    backgroundColor: PUZZLE_GRID_COLORS.BACKGROUND_LIGHT,
                    userSelect: 'none',
                    display: 'grid',
                    gridTemplateColumns: `repeat(${gridSize}, ${cellSize}px)`,
                    gridTemplateRows: `repeat(${gridSize}, ${cellSize}px)`,
                    gap: 0,
                    borderRadius: 1,
                    width: `${containerSize}px`,
                    height: `${containerSize}px`,
                    transition: 'all 0.3s ease',
                    margin: '0 auto',
                    flexShrink: 0,
                    boxSizing: 'border-box',
                    justifyItems: 'stretch',
                    alignItems: 'stretch'
                }}
            >
                {grid.map((row, rowIndex) =>
                    row.map((cell, colIndex) => {
                        const isHighlighted = currentWord && currentWord.positions?.some(
                            (pos, index) => pos.row === rowIndex && pos.col === colIndex && 
                            (characterIndex < 0 || index <= characterIndex)
                        );

                        return (
                            <Box
                                key={`${rowIndex}-${colIndex}`}
                                sx={{
                                    width: `${cellSize}px`,
                                    height: `${cellSize}px`,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: isHighlighted ? PUZZLE_GRID_COLORS.GREEN_FOUND : PUZZLE_GRID_COLORS.WHITE,
                                    color: isHighlighted ? PUZZLE_GRID_COLORS.TEXT_DARK : PUZZLE_GRID_COLORS.TEXT_DARK,
                                    fontFamily: "'Open Sans', sans-serif",
                                    fontSize: isHighlighted ? `${fontHi}rem` : `${fontNorm}rem`,
                                    fontWeight: isHighlighted ? 700 : 400,
                                    letterSpacing: isHighlighted ? '0.05em' : 'normal',
                                    border: `1px solid ${PUZZLE_GRID_COLORS.BORDER_LIGHT}`,
                                    borderRadius: 0.25,
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        backgroundColor: isHighlighted ? PUZZLE_GRID_COLORS.GREEN_FOUND_HOVER : PUZZLE_GRID_COLORS.HOVER_BACKGROUND
                                    }
                                }}
                            >
                                {cell || ""}
                            </Box>
                        );
                    })
                )}
            </Paper>
        </Box>
    );
};

export default WordGrid;

